import styled from 'styled-components';
import * as Styles from '../styles';

export const Container = styled(Styles.Container)`
    letter-spacing: 0.7px !important;
`;

export const Label = styled(Styles.Label)`
    margin: 0 2px;
    `;

export const InputContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    min-height: 9px;
    padding: 0 0 0 5px;
`;
